// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { PrescriptionActions, PrescriptionActionTypes } from '../_actions/prescription.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { Prescription } from '../_models/prescription.model';

// tslint:disable-next-line:no-empty-interface
export interface PrescriptionsState extends EntityState<Prescription> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedPrescriptionId: number;
  lastCreatedPrescription: Prescription;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Prescription> = createEntityAdapter<Prescription>();

export const initialPrescriptionsState: PrescriptionsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedPrescriptionId: undefined,
  lastCreatedPrescription: undefined,
  showInitWaitingMessage: true,
});

export function prescriptionsReducer(
  state = initialPrescriptionsState,
  action: PrescriptionActions,
): PrescriptionsState {
  switch (action.type) {
    case PrescriptionActionTypes.PrescriptionsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedPrescriptionId: undefined,
      };
    case PrescriptionActionTypes.PrescriptionsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case PrescriptionActionTypes.PrescriptionCreated:
      return adapter.addOne(action.payload.prescription, {
        ...state,
        lastCreatedPrescriptionId: action.payload.prescription.id,
        lastCreatedPrescription: action.payload.prescription,
      });
    case PrescriptionActionTypes.PrescriptionUpdated:
      return adapter.updateOne(action.payload.partialPrescription, state);
    case PrescriptionActionTypes.PrescriptionDeleted:
      return adapter.removeOne(action.payload.id, state);
    case PrescriptionActionTypes.PrescriptionsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case PrescriptionActionTypes.PrescriptionsPageLoaded: {
      return adapter.addMany(action.payload.prescriptions, {
        ...initialPrescriptionsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case PrescriptionActionTypes.ThrowPrescriptionError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case PrescriptionActionTypes.FirePrescriptionSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    case PrescriptionActionTypes.ClearPrescriptionState: {
      return initialPrescriptionsState;
    }
    default:
      return state;
  }
}

export const getPrescriptionState = createFeatureSelector<PrescriptionsState>('prescriptions');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
